import { useState, useCallback } from "react"
import produce from "immer"

export const useImmer = initialState => {
  const [state, setState] = useState(initialState)
  const update = useCallback(updateFn => setState(produce(updateFn)), [])
  return [state, update]
}
